// extracted by mini-css-extract-plugin
export default {"tabs":"MessagingDropdown_tabs__i8htv","tab":"MessagingDropdown_tab__rFJv6"};